import { DefaultAvatar } from '@mogul/shared';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../styles.module.css';

const OpenIcon = () => (
  <svg height="84" width="84" className={styles.overlayCircle}>
    <circle
      cx="42"
      cy="42"
      r="40"
      stroke="#FDD65A"
      strokeWidth="4"
      strokeOpacity="1"
      fill="transparent"
    />
  </svg>
);

const CloseIcon = () => (
  <svg height="36" width="36" className={styles.overlayCircleSM}>
    <circle
      cx="18"
      cy="18"
      r="17"
      stroke="#FDD65A"
      strokeWidth="2"
      strokeOpacity="1"
      fill="transparent"
    />
  </svg>
);

interface Props {
  isOpen: boolean;
  image?: string;
}

export const Profile = ({ isOpen, image }: Props) => {
  const cn = clsx(
    styles.displayPic,
    isOpen ? styles.userProfile : styles.userProfileSM,
  );

  return (
    <div className={styles.profileInfo}>
      {isOpen ? <OpenIcon /> : <CloseIcon />}
      <Link to={'/platform/profile'} className={cn}>
        <img src={`${image ?? DefaultAvatar}`} alt="Profile" />
      </Link>
    </div>
  );
};
